import { StyleProp, ViewStyle, NativeSyntheticEvent, NativeScrollEvent } from 'react-native';
import type { DbInfiniteListRef } from '../../DbInfiniteList/DbInfiniteList.types';
import type { ChatMessageData } from '../DbChatMessage/types';

/** DbChatList 暴露的 ref 方法（继承自 DbInfiniteListRef） */
export type DbChatListRef = DbInfiniteListRef;

/** 消息列表组件 Props */
export interface DbChatListProps {
    /** 消息列表 */
    messages: ChatMessageData[];
    /** 当前用户 ID（用于判断方向） */
    currentUserId?: string;
    /** 是否显示头像（对方消息） */
    showAvatar?: boolean;
    /** 是否显示我的头像（右侧/自己发送的消息） */
    showMyAvatar?: boolean;
    /** 是否显示时间 */
    showTime?: boolean;
    /** 是否显示状态 */
    showStatus?: boolean;
    /** 是否显示发送者名称 */
    showSenderName?: boolean;
    /** 重试回调 */
    onRetry?: (id: string) => void;
    /** 长按回调 */
    onLongPress?: (message: ChatMessageData) => void;
    /** 点击头像回调 */
    onAvatarPress?: (message: ChatMessageData) => void;
    /** 滚动事件回调 */
    onScroll?: (event: NativeSyntheticEvent<NativeScrollEvent>) => void;
    /** 滚动开始拖动回调 */
    onScrollBeginDrag?: (event: NativeSyntheticEvent<NativeScrollEvent>) => void;
    /** 滚动结束拖动回调 */
    onScrollEndDrag?: (event: NativeSyntheticEvent<NativeScrollEvent>) => void;
    /** 自定义样式 */
    style?: StyleProp<ViewStyle>;
    /** 列表头部组件 */
    ListHeaderComponent?: React.ReactElement;
    /** 列表底部组件 */
    ListFooterComponent?: React.ReactElement;
}

/** 时间分割线显示的时间间隔（毫秒） */
export const TIME_DIVIDER_INTERVAL = 5 * 60 * 1000; // 5 分钟
